import axios from 'axios';
import { getApiUrl, parseMgkResponse } from '@/config/api';

const BASE = '/api/SatMetodoPago';

export default {
  async listarGlobal(filtro = {}) {
    const response = await axios.post(getApiUrl(`${BASE}/listar-global`), filtro);
    const data = response.data;
    return Array.isArray(data) ? data : (data?.OData || []);
  },

  async guardarGlobal(model) {
    const response = await axios.post(getApiUrl(`${BASE}/guardar-global`), model);
    return parseMgkResponse(response);
  },

  async borrarGlobal(model) {
    const response = await axios.post(getApiUrl(`${BASE}/borrar-global`), model);
    return parseMgkResponse(response);
  },

  async listarEmpresa(filtro = {}) {
    const response = await axios.post(getApiUrl(`${BASE}/listar-empresa`), filtro);
    const data = response.data;
    return Array.isArray(data) ? data : (data?.OData || []);
  },

  async guardarEmpresa(model) {
    const response = await axios.post(getApiUrl(`${BASE}/guardar-empresa`), model);
    return parseMgkResponse(response);
  },

  async borrarEmpresa(model) {
    const response = await axios.post(getApiUrl(`${BASE}/borrar-empresa`), model);
    return parseMgkResponse(response);
  },

  async copiarGlobalAEmpresa(model) {
    const response = await axios.post(getApiUrl(`${BASE}/copiar-global-a-empresa`), model);
    return parseMgkResponse(response);
  }
};
